/**
 * Cross-tab reveal context: lets any descendant trigger a card reveal in the
 * Blueprint tab without prop-drilling through DocumentsTab / SourcesPanel /
 * CareDeliveryChat.
 *
 * The context value is a callback. Pass it via {@link RevealCardContext.Provider} in
 * {@link AppContent}. Components consume it with {@link useRevealCard}.
 * Nothing is logged (HIPAA).
 */
import { createContext, useContext } from "react";

/** Signature of the reveal callback. */
export type RevealCardFn = (targetId: string) => void;

/**
 * Context carrying the reveal callback. Defaults to a no-op so consumers
 * outside a provider still compile and run without errors.
 */
export const RevealCardContext = createContext<RevealCardFn>(() => undefined);

/**
 * Consume the reveal callback.
 *
 * @returns The reveal callback from the nearest {@link RevealCardContext} provider.
 */
export function useRevealCard(): RevealCardFn {
  return useContext(RevealCardContext);
}
